import React from 'react';
import { Button } from '../../../../../components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../../../components/ui/dialog';
import { Download, FileText, X, Trash2 } from 'lucide-react';
import { SpecificationDocument } from '../../../types/index';

interface DocumentDownloadModalProps {
  isOpen: boolean;
  onClose: () => void;
  documents: any[];
  onDownload: (spec: any) => void;
  onDelete?: (doc: any) => void;
  title?: string;
  canDelete?: boolean;
}

export const DocumentDownloadModal: React.FC<DocumentDownloadModalProps> = ({
  isOpen,
  onClose,
  documents,
  onDownload,
  onDelete,
  title = 'Download Documents',
  canDelete = false
}) => {
  const handleDownload = (spec: any) => {
    onDownload(spec);
  };


  const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="w-[90vw] max-w-[1200px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FileText className="h-5 w-5" />
            {title} ({documents.length} files)
          </DialogTitle>
        </DialogHeader>

        <div className="py-4 max-h-96 overflow-y-auto">
          {documents.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              No documents available for download
            </div>
          ) : (
            <div className="space-y-3">
              {documents
                .sort((a, b) => {
                  const dateA = a.uploadDate ? new Date(a.uploadDate).getTime() : 0;
                  const dateB = b.uploadDate ? new Date(b.uploadDate).getTime() : 0;
                  return dateB - dateA; // Descending order (newest first)
                })
                .map((doc, index) => (

                <>    {doc.fileName && <div
                  key={doc.id || index}
                  className="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
                >
                  <div className="flex items-center gap-3 flex-1 min-w-0">
                    <FileText className="h-5 w-5 text-gray-500 flex-shrink-0" />
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-gray-900 truncate">
                        {doc.fileName}
                      </p>
                      <div className="flex items-center gap-4 text-xs text-gray-500">
                        <span>{formatDate(doc.uploadDate)}</span>
                        <span className="capitalize">{doc.type?.toLowerCase().replace('_', ' ')}</span>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 flex-shrink-0">
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => handleDownload(doc)}
                      className="flex items-center gap-2"
                    >
                      <Download className="h-4 w-4" />
                    </Button>
                    {canDelete && onDelete && (
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => onDelete(doc)}
                        className="flex items-center gap-2 text-red-600 hover:text-red-700 hover:bg-red-50"
                      >
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    )}
                  </div>
                </div>
                }
                </>
              ))}
            </div>
          )}
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={onClose}
            className="flex items-center gap-2"
          >
         
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}; 